<template lang="pug">
.pis-cofins-credit-ncm-list

  section
    el-header
      el-col(:span="24")
        el-page-header(@back="back" content="NCMs com crédito de PIS/COFINS")

    el-card(shadow="never")
      p
        | Compras de itens com estes NCMs geram crédito de PIS/COFINS. Os demais, como a maioria dos cosméticos
        | (tributados de forma monofásica pelo fabricante), não geram crédito. O NCM considerado é o da nota do fornecedor.

      el-form(ref="form" :model="newNcm" :rules="rules" :inline="true" @submit.native.prevent)
        el-form-item(label="NCM" prop="ncm")
          el-input(v-model="newNcm.ncm" placeholder="0000.00.00" maxlength="10")
        el-form-item(label="Alíquota (%)" prop="rate")
          el-input-number(v-model="newNcm.rate" :precision="2" :step="0.05" :min="0.01" :max="100" controls-position="right")
        el-form-item
          el-button(type="primary" icon="el-icon-plus" :loading="saving" @click="save") Salvar

    el-table(:data="ncms" v-loading="loading" size="mini")
      el-table-column(label="NCM" width="160")
        template(slot-scope="scope") {{ formatNcm(scope.row.ncm) }}
      el-table-column(label="Alíquota (%)" width="140" align="right")
        template(slot-scope="scope") {{ formatNumber(scope.row.rate) }}
      el-table-column(label="Atualizado em")
        template(slot-scope="scope") {{ formatDate(scope.row.updatedAt) }}
      el-table-column(width="80" align="center" fixed="right")
        template(slot-scope="scope")
          el-button(size="mini" type="danger" plain icon="el-icon-delete" @click="remove(scope.row)")

</template>
<script setup>
import { getCurrentInstance, onMounted, ref } from 'vue'
import { useRouter } from 'vue2-helpers/vue-router'

import PisCofinsCreditNcmService from '@/services/fiscal/PisCofinsCreditNcmService'
import { useMessage } from '@/utils/Message'
import { formatDate, formatNumber } from '../purchase-invoice/labels'

const router = useRouter()
const message = useMessage()
const confirm = getCurrentInstance().proxy.$confirm

const form = ref()
const loading = ref(true)
const saving = ref(false)
const ncms = ref([])
const newNcm = ref({ ncm: '', rate: 9.25 })

const rules = {
  ncm: [
    { required: true, message: 'Informe o NCM', trigger: 'blur' },
    { pattern: /^\d{4}\.?\d{2}\.?\d{2}$/, message: 'O NCM deve ter 8 dígitos', trigger: 'blur' },
  ],
  rate: [{ required: true, message: 'Informe a alíquota', trigger: 'blur' }],
}

const formatNcm = ncm => ncm.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1.$2.$3')

const back = () => router.back()

const load = async () => {
  loading.value = true

  try {
    ncms.value = await PisCofinsCreditNcmService.list()
  } catch (error) {
    message.error(`Não foi possível carregar os NCMs: ${error.description || error.message}`)
  } finally {
    loading.value = false
  }
}

const save = async () => {
  try {
    await form.value.validate()
  } catch (error) {
    return
  }

  saving.value = true

  try {
    await PisCofinsCreditNcmService.save(newNcm.value.ncm.replace(/\D/g, ''), newNcm.value.rate)
    message.success('NCM salvo.')
    newNcm.value = { ncm: '', rate: 9.25 }
    await load()
  } catch (error) {
    message.error(`Não foi possível salvar o NCM: ${error.description || error.message}`)
  } finally {
    saving.value = false
  }
}

const remove = async (row) => {
  try {
    await confirm(`Remover o NCM ${formatNcm(row.ncm)}? Compras com este NCM deixam de gerar crédito.`)
  } catch (cancelled) {
    return
  }

  try {
    await PisCofinsCreditNcmService.remove(row.ncm)
    message.success('NCM removido.')
    await load()
  } catch (error) {
    message.error(`Não foi possível remover o NCM: ${error.description || error.message}`)
  }
}

onMounted(load)
</script>
<style lang="scss" scoped>
.el-table {
  margin-top: 16px;
}
</style>
